import { CampaignStoreItemTypes } from '#api/new/types/utils';
import { PeerParticipantsWith__Type } from '@givebacks/api/store';

import { SetupBannerImageModal } from './SetupBannerImageModal';
import { SetupCompleteModal } from './SetupCompleteModal';
import { SetupDonationNotificationsModal } from './SetupDonationNotificationsModal';
import { SetupFundraisingDescriptionModal } from './SetupFundraisingDescriptionModal';
import { SetupPeerPageModalIds } from './SetupPeerPage.types';
import { SetupPeerPageModalProvider } from './SetupPeerPageModalProvider';

const SetupPeerPageModalFlow = ({
  peer,
  campaign,
  children,
  defaultOpen,
  onClose,
}: {
  peer: PeerParticipantsWith__Type;
  campaign: CampaignStoreItemTypes;
  children: React.ReactNode;
  defaultOpen?: SetupPeerPageModalIds;
  onClose?: () => void;
}) => {
  return (
    <SetupPeerPageModalProvider
      meta={{ peer, campaign }}
      defaultOpen={defaultOpen}
      onClose={onClose}
    >
      <SetupBannerImageModal />
      <SetupFundraisingDescriptionModal />
      <SetupDonationNotificationsModal />
      <SetupCompleteModal />
      {children}
    </SetupPeerPageModalProvider>
  );
};
export { SetupPeerPageModalFlow };
